import React, { Fragment, useState } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../../components/table/tableComponent";
import { TbEdit } from "react-icons/tb";
import { HiOutlineTrash } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { _removeSession } from "../../../../../../store/slices/baseSetup.slice";
import { deleteSession } from "../../../../../../services/workspace/session.service";
import { Link } from "react-router-dom";
import ConfirmModal from "../../../../../components/modals/ConfirmModel";
import toast from "react-hot-toast";
import TableSkeleton from "../../../../../components/skeleton/tableSkeleton";
import {
  COMMON_PERMISSIONS,
  dateFormat,
  MODULES_LIST,
  SUB_MODULES_LIST,
} from "../../../../../../utils/helper";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import RenderActionButtons from "../../../../../../utils/renderActionButtons";

const TableHeaderData = [
  "Student Name",
  "Roll Number",
  "Class/Grade",
  "Subject",
  "Total Marks",
  "Marks Obtained",
  "Percentage",
  "Weightage percentage",
  "Term weightage percentage",
  "Remarks",
  
];

const ExaminationReportTable = ({
  data = [],
  loading = true,
  removeSessionFromState = () => null,
  search = "",
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const onConfirm = () => {
    deleteSession(selectedId)
      .then((response) => {
                        dispatch(_removeSession(selectedId));
        removeSessionFromState(selectedId);
        toast.success("Session deleted successfully!");
      })
      .catch((error) => {
        toast.error(
          `Failed to delete session: ${
            error.response?.data?.message || "Unknown error"
          }`
        );
        console.error(error);
      });
    setIsOpen(false);
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const _actions = (item) => [
    {
      access: COMMON_PERMISSIONS.UPDATE,
      component: (
        <Link
          to={`/configuration/manage-sessions/edit/${item.uuid}`}
          className="text-xl"
        >
          <DefaultButton variant="iconButton" name={<TbEdit />} />
        </Link>
      ),
    },
    {
      access: COMMON_PERMISSIONS.DELETE,
      component: (
        <DefaultButton
          onClick={() => handleDelete(item.uuid)}
          variant="iconButton"
          name={<HiOutlineTrash />}
        />
      ),
    },
  ];

  return (
    <Fragment>
      <Table className="shadow-md">
        <TableHeader>
          <TableRow>
            {TableHeaderData.map((header, index) => (
              <TableHead
                sticky={index === TableHeaderData.length - 1}
                key={index}
              >
                {header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            <TableSkeleton colSpan={TableHeaderData.length} />
          ) : (
            <Fragment>
              {data.length > 0 ? (
                data.map((item, i) => (
                  <TableRow key={i}>
                    <TableCell>{`${item?.first_name} ${item.last_name}`}</TableCell>
                    {/* <TableCell>{item.abrv || "-"}</TableCell> */}
                    <TableCell>{item?.roll_no}</TableCell>
                    <TableCell>
                      {item?.active_class?.class?.name || "-"}
                    </TableCell>
                    <TableCell>
                      {item?.exam_result_summany?.total_subjects || "-"}
                    </TableCell>
                    <TableCell>
                      {item?.exam_result_summany?.total_marks || "-"}
                    </TableCell>
                    <TableCell>
                      {item?.exam_result_summany?.total_obtained_marks || "-"}
                    </TableCell>
                    <TableCell>
                      {item?.exam_result_summany?.percentage || "-"}
                    </TableCell>
                    <TableCell>
                      {item?.exam_result_summany?.weightage_percentage || "-"}
                    </TableCell>
                    <TableCell>
                      {item?.exam_result_summany?.term_weightage_percentage || "-"}
                    </TableCell>
                    <TableCell sticky className="flex items-center gap-2 ">
                      {/* <RenderActionButtons
                        empty
                        actions={_actions(item)} // Pass item to dynamically generate actions
                        module={MODULES_LIST.BASIC_SETUP}
                        submodule={SUB_MODULES_LIST.BASIC_SETUP.SESSION}
                      /> */}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <NoDataFound
                    colSpan={TableHeaderData.length}
                    search={search}
                    text={"No sessions found."}
                  />
                </TableRow>
              )}
            </Fragment>
          )}
        </TableBody>
      </Table>

      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={isOpen}
        title="Are you sure?"
        message="Do you really want to delete this record? This process cannot be undone."
        onConfirm={onConfirm}
        onCancel={() => setIsOpen(false)}
      />
    </Fragment>
  );
};

export default ExaminationReportTable;
